module.exports = __webpack_public_path__ + "img/customer_medium.34246a24.jpg";